import React from "react";

import Demo from "@/assets/images/Demo.png";

export const LoginSidebar: React.FC = () => {
  return (
    <div className="col-span-3 justify-between bg-primary-100 p-5 flex flex-col relative">
      <div className="md:pt-[40%] text-center px-4">
        <img
          src={Demo}
          alt="TAGA Platform Demo"
          className="mb-4 mx-auto"
          loading="lazy"
        />
        <h2 className="text-[24px] font-bold mb-3">
          Nền tảng làm việc trọn gói của bạn
        </h2>
        <p className="text-gray-700">
          Quản lý thông tin, quy trình làm việc và con người, tất cả ở cùng một
          nơi.
        </p>
      </div>

      <div className="text-xs text-right">
        <p className="opacity-40">Developed by/</p>
        <p className="opacity-60 uppercase">TAGA Joint Stock Company @2024</p>
      </div>
    </div>
  );
};
